import MuiTimePicker from '@mui/lab/TimePicker';
import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { timeShowFormat } from '../../../types/core/date.types';

interface Props {
  label: string;
  controllerProps: any;
  errors?: any;
  readOnly?: boolean;
  isRequired?: boolean;
}

export function TimePicker({ label, controllerProps, errors, readOnly, isRequired }: Props) {
  return (
    <Controller
      {...controllerProps}
      render={({ field }) => (
        <MuiTimePicker
          ampm={false}
          label={label}
          inputFormat={timeShowFormat}
          mask="__:__"
          onChange={(e) => field.onChange(e)}
          value={field.value}
          disabled={readOnly}
          renderInput={(params) => {
            return (
              <TextField
                fullWidth
                {...params}
                InputProps={{ ...params.InputProps, readOnly, disabled: readOnly }}
                error={Boolean(errors[controllerProps.name])}
                required={isRequired}
                helperText={errors[controllerProps.name]?.message}
              />
            );
          }}
        />
      )}
    />
  );
}
